// Icons
import { FiMapPin } from "react-icons/fi";

import { BsGithub, BsLinkedin, BsInstagram } from "react-icons/bs";
import { SiHackthebox } from "react-icons/si";

// Companies icons
const impact = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/companies/impact_v6fcdp.png";
const edmondDeRothschild = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/companies/EdmondDeRothschild_j66fo5.png";
const perach = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528785/portfolio/companies/perach_jg1ee8.png";
const educatingForExcellence = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528785/portfolio/companies/EducatingForExcellence_l9wx8e.png";

// Languages images
const typescript = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754342583/portfolio/languages/Typescript.svg-removebg-preview_popty8_1_qvmtu3.png";
const c = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528787/portfolio/languages/c_rvagna.png";
const cSharp = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528787/portfolio/languages/c-sharp_e1mwcj.png";
const cPlusPlus = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528787/portfolio/languages/c_dcdpx7.png";
const java = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528787/portfolio/languages/java_zvdpeb.png";
const php = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528788/portfolio/languages/php_qv24xo.png";
const python = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528788/portfolio/languages/python_evvhv8.png";
const assembly = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528786/portfolio/languages/assembly_kdkamx.png";
const javascript = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528787/portfolio/languages/javascript_s20j2y.png";
const html5 = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528787/portfolio/languages/html5_doffnw.png";
const css3 = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528787/portfolio/languages/css3_xaw0ca.png";

// Technologies and Tools images
const aws = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754342583/portfolio/technologies%20and%20tools/Amazon_Web_Services_Logo.svg_uhnnfk_1_x5jodc.png";
const mixpanel = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754303141/portfolio/technologies%20and%20tools/mixpanel_ol5fcu.png";
const frontegg = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754344640/portfolio/technologies%20and%20tools/e7fca6b4-535b-4b28-ab5c-ca87d52757c6-removebg-preview_dmz5dp.png";
const bitbucket = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754303380/portfolio/technologies%20and%20tools/logo-743959029541_gn4wbs.png";
const jira = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754303442/portfolio/technologies%20and%20tools/jira-1_h9vod3.svg";
const slack = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754303490/portfolio/technologies%20and%20tools/Slack-Logo_i3uhrt.png";
const vsStudio = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528790/portfolio/technologies%20and%20tools/vsStudio_kkulx8.png";
const vsCode = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528790/portfolio/technologies%20and%20tools/vsCode_corder.png";
const eclipse = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528789/portfolio/technologies%20and%20tools/eclipse_eij0t4.png";
const pycharm = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528790/portfolio/technologies%20and%20tools/pycharm_gii7sy.png";
const nodejs = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754343338/portfolio/technologies%20and%20tools/nodejs-new-pantone-white_zkadzw.png";
const postman = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528789/portfolio/technologies%20and%20tools/postman_axot5t.png";
const wireshark = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528790/portfolio/technologies%20and%20tools/wireshark_seyqop.png";
const metasploit = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528789/portfolio/technologies%20and%20tools/metasploit_rif5lv.png";
const nmap = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528789/portfolio/technologies%20and%20tools/nmap_ppw9cs.png";
const burp = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528788/portfolio/technologies%20and%20tools/burp_uaoypc.png";
const JohnTheRipper = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528789/portfolio/technologies%20and%20tools/JohnTheRipper_qwlox9.png";

// Web & CMS Platforms
const wordpress = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754343810/portfolio/Web%20and%20CMS%20Platforms/WordPress_blue_logo.svg_e0dnme_1_jht1xe.png";
const upress = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754345180/portfolio/Web%20and%20CMS%20Platforms/favicon_1_ilszbk.png";

// Background images
const git = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/background/git_voje9w.png";
const github = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/background/github_wrxroo.png";
const bootstrap = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528783/portfolio/background/bootstrap_mnofyj.png";
const reactjs = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/background/reactjs_keefpx.png";
const express = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1754345832/portfolio/background/1_3b1Txj9aSBQfUSQzCZBO-Q-removebg-preview_1_bmu2gb.png";
const docker = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528783/portfolio/background/docker_s3cpoy.png";
const proxmox = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/background/proxmox_uoopkw.png";
const vmware = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/background/vmware_yheg6v.png";
const vbox = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528785/portfolio/background/vbox_zzobl5.png";
const owasp = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/background/owasp_dzdduy.png";
const regex = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528784/portfolio/background/regex_ivqnou.png";

// Databases images
const mongodb = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656581246/portfolio/databases/mongodb_kem5yn_v9nzjb.png";
const mysql = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528786/portfolio/databases/mysql_p9igpl.png";
const sql_server = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528786/portfolio/databases/sql_server_tkxv7q.png";

// Systems images
const windows = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528795/portfolio/systems/windows_zivf9e.png";
const linux = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528788/portfolio/systems/linux_kiu2vk.png";
const kali = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528788/portfolio/systems/kali_zht7zu.png";
const ubuntu = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528789/portfolio/systems/ubuntu_o2qob3.png";
const centos = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528789/portfolio/systems/centos_jhdli3.png";

// Navigation
export const navigation = [
  {
    name: "home",
    href: "home",
  },
  {
    name: "about",
    href: "about",
  },
  {
    name: "skills",
    href: "skills",
  },
  {
    name: "HTB - Walkthrough",
    href: "HTB - Walkthrough",
  },
  {
    name: "contact",
    href: "contact",
  },
];

// Social
export const social = [
  {
    icon: <BsGithub />,
    href: "https://github.com/haimazu",
  },
  {
    icon: <BsLinkedin />,
    href: "https://www.linkedin.com/in/haimazulay",
  },
  {
    icon: <BsInstagram />,
    href: "https://www.instagram.com/_haimazulay",
  },
  {
    icon: <SiHackthebox />,
    href: "https://app.hackthebox.com/profile/165013",
  },
];

// Companies
export const companies = [
  {
    image: impact,
  },
  {
    image: edmondDeRothschild,
  },
  {
    image: perach,
  },
  {
    image: educatingForExcellence,
  },
];

/* Professional Skills */

// Programming / Tag languages
export const Languages = [
  {
    image: typescript,
  },
  {
    image: c,
  },
  {
    image: cSharp,
  },
  {
    image: cPlusPlus,
  },
  {
    image: java,
  },
  {
    image: php,
  },
  {
    image: python,
  },
  {
    image: assembly,
  },
  {
    image: javascript,
  },
  {
    image: html5,
  },
  {
    image: css3,
  },
];

// Technologies and Tools
export const Tat = [
  {
    image: aws,
  },
  {
    image: mixpanel,
  },
  {
    image: frontegg,
  },
  {
    image: bitbucket,
  },
  {
    image: jira,
  },
  {
    image: slack,
  },
  {
    image: vsStudio,
  },
  {
    image: vsCode,
  },
  {
    image: eclipse,
  },
  {
    image: pycharm,
  },
  {
    image: nodejs,
  },
  {
    image: postman,
  },
  {
    image: wireshark,
  },
  {
    image: metasploit,
  },
  {
    image: nmap,
  },
  {
    image: burp,
  },
  {
    image: JohnTheRipper,
  },
];

// Background
export const Platforms = [
  {
    image: wordpress,
  },
  {
    image: upress,
  },
];

// Background
export const Background = [
  {
    image: git,
  },
  {
    image: github,
  },
  {
    image: bootstrap,
  },
  {
    image: reactjs,
  },
  {
    image: express,
  },
  {
    image: docker,
  },
  {
    image: proxmox,
  },
  {
    image: vmware,
  },
  {
    image: vbox,
  },
  {
    image: owasp,
  },
  {
    image: regex,
  },
];

// Databases
export const Databases = [
  {
    image: mongodb,
  },
  {
    image: mysql,
  },
  {
    image: sql_server,
  },
];

// Systems
export const Systems = [
  {
    image: windows,
  },
  {
    image: linux,
  },
  {
    image: kali,
  },
  {
    image: ubuntu,
  },
  {
    image: centos,
  },
];

// Projects
// export const projectsData = [
//   {
//     project_id: "1",
//     title: "Project 1",
//     image: {
//       public_id: "portfolio/projects/wykxdg8flyqobcxnmwwe",
//       url: "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656519865/portfolio/projects/wykxdg8flyqobcxnmwwe.png"
//     },
//     description: "some text",
//     github: "https://github.com",
//     demo: "https://github.com"
//   },
//   {
//     project_id: "2",
//     title: "Project 2",
//     image: {
//       public_id: "portfolio/projects/wykxdg8flyqobcxnmwwe",
//       url: "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656519865/portfolio/projects/wykxdg8flyqobcxnmwwe.png"
//     },
//     description: "some text",
//     github: "https://github.com",
//     demo: "https://github.com"
//   },
//   {
//     project_id: "3",
//     title: "Project 2",
//     image: {
//       public_id: "portfolio/projects/wykxdg8flyqobcxnmwwe",
//       url: "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656519865/portfolio/projects/wykxdg8flyqobcxnmwwe.png"
//     },
//     description: "some text",
//     github: "https://github.com",
//     demo: "https://github.com"
//   },
//   {
//     project_id: "4",
//     title: "Project 2",
//     image: {
//       public_id: "portfolio/projects/wykxdg8flyqobcxnmwwe",
//       url: "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656519865/portfolio/projects/wykxdg8flyqobcxnmwwe.png"
//     },
//     description: "some text",
//     github: "https://github.com",
//     demo: "https://github.com"
//   }
// ]

// Contact
export const contact = [
  {
    icon: <FiMapPin />,
    title: "Current Location",
    subtitle: "Tel Aviv-Yafo, Tel Aviv District, Israel",
    // description: "Open for relocation",
  },
];

// Global
export const logoImage = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528685/portfolio/logo_taq04t.png";

// Home
export const heroImage = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656528685/portfolio/hero_hacker_z4of05.png";

// About
export const aboutImage = "https://res.cloudinary.com/dzmau9ijh/image/upload/v1656526296/portfolio/Ethical-Hacking_rg9mqt.jpg";
